import { getDarkenColor, getLightenColor } from ".";

export default (type, colors) => {
  const styles = {
    default: {
      'c-typeselect__option': {
        customCSS: `
          .c-typeselect__option {
            color: ${colors.primary};
            border-top-color: ${getDarkenColor(colors.light, 0.026)};
          }
          .c-typeselect__option:hover, 
          .c-typeselect__option:active, 
          .c-typeselect__option:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
            background: ${getDarkenColor(colors.light, 0.026)};
          }
          .c-typeselect__option small {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
        `
      },
      'c-typeselect__list': { 
        boxShadow: `1px 1px ${getLightenColor(colors.secondary, 0.21)}`,
      }
    },
    type1: {
      'c-typeselect': {
        width: '83.33333%',
        float: 'left',
        paddingLeft: '0.83333rem',
        paddingRight: '0.83333rem',
        customCSS: `
          .c-typeselect:last-child:not(:first-child) {
            float: none;
            padding: 0!important;
          }
        `
      },
      'c-typeselect__option': {
        customCSS: `
          .c-typeselect__option {
            color: ${colors.primary};
            border-top-color: ${getDarkenColor(colors.light, 0.026)};
          }
          .c-typeselect__option:hover, 
          .c-typeselect__option:active, 
          .c-typeselect__option:focus {
            color: ${getDarkenColor(colors.primary, 0.07)};
            background: ${getDarkenColor(colors.light, 0.026)};
          }
          .c-typeselect__option small {
            color: ${getDarkenColor(colors.secondary_dark, 0.23)};
          }
        `
      },
      'c-typeselect__list': { 
        boxShadow: `1px 1px ${getLightenColor(colors.secondary, 0.21)}`,
      },
      'c-typeselect__button-holder': {
        position: 'absolute',
        right: 0,
      },
      'c-typeselect__button': {
        boxShadow: '0 0 0',
        background: 'transparent',
        border: 'none',
      },
      'c-typeselect__icon': {
        color: colors.dark
      },
      'c-typeselect__input-group': {
        position: 'relative',
        boxShadow: 'none'
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cTypeselect.js